import { testimonials } from "../../../mocks/home";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-4">
              A quieter, kinder way forward
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              This space is designed to help people feel less alone and more supported as they move toward change.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-14 stagger-children">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/50 relative"
              >
                <div className="text-accent-400 mb-4">
                  <i className="ri-double-quotes-l text-3xl" />
                </div>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-6 italic">
                  "{item.quote}"
                </p>
                <p className="font-body text-xs text-foreground-500 tracking-wide">
                  — {item.name}
                </p>
              </div>
            ))}
          </div>

          <div className="relative overflow-hidden rounded-lg max-w-4xl mx-auto">
            <img
              src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/c245a1b2b312163bf0af691a2304fc81.png"
              alt="A person walking alone on a peaceful winding nature path at golden sunrise, symbolising fresh start and quiet freedom"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}